import { gql } from 'graphql-tag'
import { companyFragment } from '../../company/companyQueries'

export const userFragment = gql`
  fragment UserFragment on User {
    id
    employeeId
    principalName
    samAccountName
    givenName
    surname
    name
    userType
    company {
      ...CompanyFragment
    }
  }
  ${companyFragment}
`

export const fetchUsers = gql`
  query FetchUsers($page: Int, $perPage: Int) {
    users(page: $page, perPage: $perPage) {
      total
      edges {
        node {
          ...UserFragment
        }
      }
    }
  }
  ${userFragment}
`

export const deleteUser = gql`
  mutation DeleteUser($id: ID!, $userId: ID) {
    deleteUser(id: $id, userId: $userId)
  }
`

const updateUser = gql`
  mutation UpdateUser($id: ID!, $data: UpdateUserInputType!) {
    updateUser(id: $id, data: $data) {
      ...UserFragment
    }
  }
  ${userFragment}
`

export const createExternalEmployee = gql`
  mutation CreateExternalUser($data: CreateExternalUserInputType!) {
    createExternalUser(data: $data) {
      ...UserFragment
    }
  }
  ${userFragment}
`
